import ScrollToTopOnRouteChange from "components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange";
import UserNavbar from "components/UserNavbar/UserNavbar";
import { useState, useMemo } from "react";
import {
  FaSuitcase,
  FaSearch,
  FaExternalLinkAlt,
  FaFilter,
  FaPlane,
  FaWeightHanging,
  FaDollarSign,
  FaGlobeAmericas,
  FaRegQuestionCircle,
  FaSortAlphaDown,
  FaSortAlphaUp,
  FaTimes
} from "react-icons/fa";
import { MdLuggage, MdAirplanemodeActive, MdInfo } from "react-icons/md";

function BaggageInformation() {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectedRegion, setSelectedRegion] = useState("all");

  const airlines = [
    {
      name: "Aeroflot-Russian Airlines",
      href: "https://www.aeroflot.ru/ru-en/before_and_after_fly/luggage",
      region: "Europe",
      country: "Russia",
      code: "SU"
    },
    {
      name: "Aeromexico",
      href: "https://www.aeromexico.com/us/TravelInformation/BeforeYouPurchase/RegulationsAndPolicies/baggagePolicy.html",
      region: "Americas",
      country: "Mexico",
      code: "AM"
    },
    {
      name: "Air Canada",
      href: "https://www.aircanada.com/ca/en/aco/home/plan/baggage.html",
      region: "Americas",
      country: "Canada",
      code: "AC"
    },
    {
      name: "Air China",
      href: "https://www.airchina.us/US/GB/info/checked-baggage/",
      region: "Asia",
      country: "China",
      code: "CA"
    },
    {
      name: "Air France",
      href: "https://wwws.airfrance.us/information/guide",
      region: "Europe",
      country: "France",
      code: "AF"
    },
    {
      name: "Air India",
      href: "https://www.airindia.com/in/en/travel-information/baggage-guidelines/checked-baggage-allowance.html",
      region: "Asia",
      country: "India",
      code: "AI"
    },
    {
      name: "Air New Zealand",
      href: "https://www.airnewzealand.com/optional-fees#checkedbaggage",
      region: "Oceania",
      country: "New Zealand",
      code: "NZ"
    },
    {
      name: "Air Transat",
      href: "https://www.airtransat.ca/en/Info/what-you-can-bring---weight-and-size.aspx?ExitID=25&ContentType=voyageur",
      region: "Americas",
      country: "Canada",
      code: "TS"
    },
    {
      name: "Alaska Airlines",
      href: "https://www.alaskaair.com/content/travel-info/baggage/checked-bags",
      region: "Americas",
      country: "USA",
      code: "AS"
    },
    {
      name: "Alitalia",
      href: "https://www.ita-airways.com/en_in",
      region: "Europe",
      country: "Italy",
      code: "AZ"
    },
    {
      name: "American Airlines",
      href: "https://www.aa.com/i18n/travel-info/baggage/checked-baggage-policy.jsp",
      region: "Americas",
      country: "USA",
      code: "AA"
    },
    {
      name: "Asiana Airlines",
      href: "https://flyasiana.com/C/US/EN/contents/free-baggage",
      region: "Asia",
      country: "South Korea",
      code: "OZ"
    },
    {
      name: "Austrian Airlines",
      href: "https://www.austrian.com/in/en/homepage",
      region: "Europe",
      country: "Austria",
      code: "OS"
    },
    {
      name: "AviancaTaca",
      href: "https://www.avianca.com/en/information-and-help/baggage/",
      region: "Americas",
      country: "Colombia",
      code: "AV"
    },
    {
      name: "Bangkok Airways",
      href: "https://www.bangkokair.com/travel-information/baggage",
      region: "Asia",
      country: "Thailand",
      code: "PG"
    },
    {
      name: "Brussels Airlines",
      href: "https://www.brusselsairlines.com/be/en/extra-services/baggage",
      region: "Europe",
      country: "Belgium",
      code: "SN"
    },
    {
      name: "Cape Air",
      href: "https://www.capeair.com/flying_with_us/baggage.html",
      region: "Americas",
      country: "USA",
      code: "9K"
    },
    {
      name: "Caribbean Airlines",
      href: "https://www.caribbean-airlines.com/#/baggage/checked-baggage",
      region: "Americas",
      country: "Trinidad & Tobago",
      code: "BW"
    },
    {
      name: "China Airlines",
      href: "https://www.china-airlines.com/us/en/search?q=baggage",
      region: "Asia",
      country: "Taiwan",
      code: "CI"
    },
    {
      name: "China Eastern",
      href: "https://www.ceair.com/",
      region: "Asia",
      country: "China",
      code: "MU"
    },
    {
      name: "China Southern Airlines",
      href: "https://www.csair.com/en/order/kpxlgd.shtml",
      region: "Asia",
      country: "China",
      code: "CZ"
    },
    {
      name: "Czech Airlines",
      href: "https://www.csa.cz/en/baggage/",
      region: "Europe",
      country: "Czech Republic",
      code: "OK"
    },
    {
      name: "Delta",
      href: "https://www.delta.com/us/en/need-help/overview",
      region: "Americas",
      country: "USA",
      code: "DL"
    },
    {
      name: "Egyptair",
      href: "https://www.egyptairflight.com/baggageallowance.php",
      region: "Africa",
      country: "Egypt",
      code: "MS"
    },
    {
      name: "Emirates",
      href: "https://www.emirates.com/au/english/before-you-fly/baggage/",
      region: "Middle East",
      country: "UAE",
      code: "EK"
    },
    {
      name: "Ethiopian Airlines",
      href: "https://www.ethiopianairlines.com/in/information/baggage-information/carry-on-baggage",
      region: "Africa",
      country: "Ethiopia",
      code: "ET"
    },
    {
      name: "Etihad Airways",
      href: "https://www.etihad.com/en/fly-etihad/baggage",
      region: "Middle East",
      country: "UAE",
      code: "EY"
    },
    {
      name: "Finnair",
      href: "https://www.finnair.com/finnaircom/wps/portal/matkustusohjeet/en_INT",
      region: "Europe",
      country: "Finland",
      code: "AY"
    },
    {
      name: "Flybe",
      href: "https://www.flybe.com/flightInfo/baggage.htm",
      region: "Europe",
      country: "UK",
      code: "BE"
    },
    {
      name: "Frontier Airlines",
      href: "https://www.flyfrontier.com/travel/travel-info/bag-options/",
      region: "Americas",
      country: "USA",
      code: "F9"
    },
    {
      name: "Hainan Air",
      href: "https://www.hainanairlines.com/INT/GB/BASV",
      region: "Asia",
      country: "China",
      code: "HU"
    },
    {
      name: "Hawaiian Airlines",
      href: "https://hawaiianair.custhelp.com/app/answers/detail/a_id/80/~/baggage-fees-%26-policies",
      region: "Oceania",
      country: "USA",
      code: "HA"
    },
    {
      name: "Iberia",
      href: "https://www.iberia.com/luggage/allowance-in-hold/",
      region: "Europe",
      country: "Spain",
      code: "IB"
    },
    {
      name: "Japan Airlines",
      href: "https://www.jal.co.jp/jp/en/inter/baggage/",
      region: "Asia",
      country: "Japan",
      code: "JL"
    },
    {
      name: "JetBlue Airways",
      href: "https://www.jetblue.com/at-the-airport/baggage-information",
      region: "Americas",
      country: "USA",
      code: "B6"
    },
    {
      name: "Jet Airways",
      href: "https://airlinesbaggage.com/jet-airways-baggage-allowance-fees/",
      region: "Asia",
      country: "India",
      code: "9W"
    },
    {
      name: "KLM",
      href: "https://www.klm.com/information/baggage/checked-baggage-allowance",
      region: "Europe",
      country: "Netherlands",
      code: "KL"
    },
    {
      name: "Korean Air",
      href: "https://www.koreanair.com/in/en/airport/baggage/overview",
      region: "Asia",
      country: "South Korea",
      code: "KE"
    },
    {
      name: "LAN Airlines",
      href: "https://www.latamairlines.com/ca/en/help-center/faq/baggage/hold/allow-flight",
      region: "Americas",
      country: "Chile",
      code: "LA"
    },
    {
      name: "Lufthansa",
      href: "https://www.lufthansa.com/fr/en/free-baggage-rules",
      region: "Europe",
      country: "Germany",
      code: "LH"
    },
    {
      name: "Luxair",
      href: "https://www.luxair.lu/en/information/baggage",
      region: "Europe",
      country: "Luxembourg",
      code: "LG"
    },
    {
      name: "Malaysia Airlines",
      href: "https://www.malaysiaairlines.com/hq/en/travel-info/baggage.html",
      region: "Asia",
      country: "Malaysia",
      code: "MH"
    },
    {
      name: "Philippine Airlines",
      href: "https://www.philippineairlines.com/before-you-fly/baggage-information/baggage-allowance/baggage-allowance-fees",
      region: "Asia",
      country: "Philippines",
      code: "PR"
    },
    {
      name: "Porter Airlines",
      href: "https://www.flyporter.com/en/travel-information/baggage/checked-allowance",
      region: "Americas",
      country: "Canada",
      code: "PD"
    },
    {
      name: "Qantas Airways",
      href: "https://www.qantas.com/in/en/travel-info/baggage/additional-baggage.html",
      region: "Oceania",
      country: "Australia",
      code: "QF"
    },
    {
      name: "Qatar Airways",
      href: "https://www.qatarairways.com/en/baggage/allowance.html",
      region: "Middle East",
      country: "Qatar",
      code: "QR"
    },
    {
      name: "Royal Air Maroc",
      href: "https://www.royalairmaroc.com/us-en/checked-baggage",
      region: "Africa",
      country: "Morocco",
      code: "AT"
    },
    {
      name: "Royal Jordanian",
      href: "https://www.rj.com/en/info-and-tips/baggage-information/checked-luggage",
      region: "Middle East",
      country: "Jordan",
      code: "RJ"
    },
    {
      name: "Singapore Airlines",
      href: "https://www.singaporeair.com/en_UK/in/travel-info/baggage/checked-baggage/",
      region: "Asia",
      country: "Singapore",
      code: "SQ"
    },
    {
      name: "South African Airways",
      href: "https://www.flysaa.com/manage-fly/baggage/checked-baggage",
      region: "Africa",
      country: "South Africa",
      code: "SA"
    },
    {
      name: "Sri Lankan",
      href: "https://www.srilankan.com/bgalw?gad_source=1&gclid=CjwKCAjw88yxBhBWEiwA7cm6pRnNIDCcY6RzDfqGBNv8U-3Z80u_unjIkBilMX0DV3IB7SrUf3lpWBoChToQAvD_BwE",
      region: "Asia",
      country: "Sri Lanka",
      code: "UL"
    },
    {
      name: "Swiss International Air Lines",
      href: "https://www.swiss.com/hu/en/prepare/baggage/checked-baggage",
      region: "Europe",
      country: "Switzerland",
      code: "LX"
    },
    {
      name: "Thai Airways",
      href: "https://www.thaiairways.com/en/travel_information/baggage.page",
      region: "Asia",
      country: "Thailand",
      code: "TG"
    },
    {
      name: "Turkish Airlines",
      href: "https://www.turkishairlines.com/en-tr/any-questions/free-baggage/?gad_source=1&gclid=CjwKCAjw88yxBhBWEiwA7cm6pfT-sQBQj2njk7ieibpa8ni0k4J6fFvNqZ5h_XC_ghA0s7xT-le6LBoCSckQAvD_BwE",
      region: "Middle East",
      country: "Turkey",
      code: "TK"
    },
    {
      name: "Virgin Atlantic",
      href: "https://help.virginatlantic.com/gb/en/baggage/check-in-baggage-allowance.html",
      region: "Europe",
      country: "UK",
      code: "VS"
    },
    {
      name: "WestJet",
      href: "https://www.westjet.com/en-ca/baggage/allowance",
      region: "Americas",
      country: "Canada",
      code: "WS"
    },
  ];

  // Get unique regions
  const regions = ["all", ...new Set(airlines.map(airline => airline.region))];

  // Filter and sort airlines
  const filteredAirlines = useMemo(() => {
    return airlines
      .filter(airline => {
        const matchesSearch = airline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            airline.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            airline.code.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesRegion = selectedRegion === "all" || airline.region === selectedRegion;
        return matchesSearch && matchesRegion;
      })
      .sort((a, b) => {
        if (sortOrder === "asc") {
          return a.name.localeCompare(b.name);
        } else {
          return b.name.localeCompare(a.name);
        }
      });
  }, [searchTerm, selectedRegion, sortOrder]);

  // Group by first letter for alphabetical grouping
  const groupedAirlines = useMemo(() => {
    const groups = {};
    filteredAirlines.forEach(airline => {
      const firstLetter = airline.name.charAt(0).toUpperCase();
      if (!groups[firstLetter]) {
        groups[firstLetter] = [];
      }
      groups[firstLetter].push(airline);
    });
    return groups;
  }, [filteredAirlines]);

  return (
    <section className="min-h-screen bg-gradient-to-b from-blue-50 to-gray-100">
      <UserNavbar />
      <ScrollToTopOnRouteChange />

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="md:w-2/3">
              <div className="flex items-center gap-4 mb-6">
                <div className="p-3 rounded-full bg-white/20 backdrop-blur-sm">
                  <FaSuitcase className="w-10 h-10" />
                </div>
                <div className="p-3 rounded-full bg-white/20 backdrop-blur-sm">
                  <MdLuggage className="w-10 h-10" />
                </div>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                Baggage Information
              </h1>
              <p className="text-xl text-blue-100 max-w-3xl">
                Comprehensive baggage policies and fees for major airlines worldwide. 
                Find your airline's specific baggage rules and requirements.
              </p>
            </div>
            <div className="md:w-1/3">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center gap-3 mb-4">
                  <FaRegQuestionCircle className="w-6 h-6" />
                  <h3 className="text-lg font-semibold">Need Help?</h3>
                </div>
                <p className="text-sm text-blue-100 mb-4">
                  Can't find your airline or have specific baggage questions?
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Controls Section */}
        <div className="mb-8">
          <div className="bg-white rounded-xl shadow-md p-6 mb-6">
            <div className="grid md:grid-cols-3 gap-4">
              {/* Search */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <FaSearch className="text-gray-400" />
                </div>
                <input
                  type="text"
                  placeholder="Search airlines or country..."
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <button
                    onClick={() => setSearchTerm("")}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  >
                    <FaTimes className="text-gray-400 hover:text-gray-600" />
                  </button>
                )}
              </div>

              {/* Region Filter */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <FaFilter className="text-gray-400" />
                </div>
                <select
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white"
                  value={selectedRegion}
                  onChange={(e) => setSelectedRegion(e.target.value)}
                >
                  {regions.map(region => (
                    <option key={region} value={region}>
                      {region === "all" ? "All Regions" : region}
                    </option>
                  ))}
                </select>
              </div>

              {/* Sort */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  {sortOrder === "asc" ? (
                    <FaSortAlphaDown className="text-gray-400" />
                  ) : (
                    <FaSortAlphaUp className="text-gray-400" />
                  )}
                </div>
                <select
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white"
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e.target.value)}
                >
                  <option value="asc">Sort A-Z</option>
                  <option value="desc">Sort Z-A</option>
                </select>
              </div>
            </div>

            {/* Stats */}
            <div className="mt-6 pt-6 border-t border-gray-200">
              <div className="flex flex-wrap gap-6">
                <div className="flex items-center gap-2">
                  <FaPlane className="text-blue-600" />
                  <span className="text-gray-600">{filteredAirlines.length} Airlines</span>
                </div>
                <div className="flex items-center gap-2">
                  <FaGlobeAmericas className="text-green-600" />
                  <span className="text-gray-600">{new Set(filteredAirlines.map(a => a.region)).size} Regions</span>
                </div>
                <div className="flex items-center gap-2">
                  <MdAirplanemodeActive className="text-purple-600" />
                  <span className="text-gray-6 00">{new Set(filteredAirlines.map(a => a.country)).size} Countries</span>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Tips */}
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 rounded-lg bg-blue-100">
                  <FaWeightHanging className="w-5 h-5 text-blue-600" />
                </div>
                <h4 className="font-semibold text-gray-900">Weight Limits</h4>
              </div>
              <p className="text-sm text-gray-600">
                Most airlines allow 23kg (50lb) per checked bag. Low-cost carriers often have stricter limits.
              </p>
            </div>
            <div className="bg-green-50 border border-green-200 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 rounded-lg bg-green-100">
                  <FaDollarSign className="w-5 h-5 text-green-600" />
                </div>
                <h4 className="font-semibold text-gray-900">Excess Fees</h4>
              </div>
              <p className="text-sm text-gray-600">
                Excess baggage fees vary by airline and route. Always check before you pack.
              </p>
            </div>
            <div className="bg-purple-50 border border-purple-200 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 rounded-lg bg-purple-100">
                  <MdInfo className="w-5 h-5 text-purple-600" />
                </div>
                <h4 className="font-semibold text-gray-900">Carry-on Rules</h4>
              </div>
              <p className="text-sm text-gray-600">
                Typically 7kg (15lb) including personal item. Size restrictions apply for overhead bins.
              </p>
            </div>
          </div>
        </div>

        {/* Airlines List */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="p-6 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-900">
                Airline Baggage Policies
              </h2>
              <span className="text-sm text-gray-500">
                Click any airline for detailed baggage information
              </span>
            </div>
          </div>

          {filteredAirlines.length === 0 ? (
            <div className="p-12 text-center">
              <FaSearch className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                No airlines found
              </h3>
              <p className="text-gray-500">
                Try adjusting your search or filter criteria
              </p>
            </div>
          ) : (
            <div className="p-6">
              {Object.keys(groupedAirlines).sort().map(letter => (
                <div key={letter} className="mb-8">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                      <span className="text-blue-600 font-bold text-lg">{letter}</span>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900">
                      {letter} • {groupedAirlines[letter].length} airlines
                    </h3>
                  </div>
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {groupedAirlines[letter].map((airline, index) => (
                      <a
                        key={index}
                        href={airline.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group block p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-all duration-200"
                      >
                        <div className="flex items-start justify-between mb-3">
                          <div>
                            <div className="flex items-center gap-2 mb-1">
                              <div className="w-8 h-8 rounded-md bg-blue-100 flex items-center justify-center group-hover:bg-blue-200">
                                <span className="text-blue-600 font-bold text-sm">{airline.code}</span>
                              </div>
                              <h4 className="font-semibold text-gray-900 group-hover:text-blue-600">
                                {airline.name}
                              </h4>
                            </div>
                            <div className="flex items-center gap-2">
                              <span className="inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-600">
                                <FaGlobeAmericas className="w-3 h-3" />
                                {airline.region}
                              </span>
                              <span className="text-sm text-gray-600">{airline.country}</span>
                            </div>
                          </div>
                          <FaExternalLinkAlt className="text-gray-400 group-hover:text-blue-500 transition-colors" />
                        </div>
                        <div className="flex items-center justify-between text-sm text-gray-500">
                          <span className="flex items-center gap-1">
                            <FaPlane className="w-3 h-3" />
                            Official Policy
                          </span>
                          <span className="text-xs px-2 py-1 bg-gray-100 rounded">
                            Opens in new tab
                          </span>
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Additional Information */}
        <div className="mt-8 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-8 border border-blue-200">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="md:w-2/3">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Need Personalized Assistance?
              </h3>
              <p className="text-gray-600 mb-4">
                Our travel experts can help you understand specific baggage rules for your itinerary, 
                including connections and special items like sports equipment or musical instruments.
              </p>
            </div>
            <div className="md:w-1/3">
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <FaSuitcase className="w-8 h-8 text-blue-600" />
                  <h4 className="font-semibold text-gray-900">Quick Reference</h4>
                </div>
                <ul className="space-y-3">
                  <li className="flex items-center gap-2 text-sm">
                    <div className="w-2 h-2 rounded-full bg-green-500"></div>
                    <span>Check weight limits 24h before flight</span>
                  </li>
                  <li className="flex items-center gap-2 text-sm">
                    <div className="w-2 h-2 rounded-full bg-green-500"></div>
                    <span>Tag all bags with contact info</span>
                  </li>
                  <li className="flex items-center gap-2 text-sm">
                    <div className="w-2 h-2 rounded-full bg-green-500"></div>
                    <span>Keep valuables in carry-on</span>
                  </li>
                  <li className="flex items-center gap-2 text-sm">
                    <div className="w-2 h-2 rounded-full bg-green-500"></div>
                    <span>Take photos of packed bags</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <div className="mt-8 text-center text-sm text-gray-500">
          <p>
            Note: Baggage policies are subject to change by airlines. Always verify with the airline directly before travel.
          </p>
          <p className="mt-1">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>
        </div>
      </div>
    </section>
  );
}

export default BaggageInformation;